import { Layout } from './layout';

Layout.displayName = 'SkeletonText';

export { Layout as Text };
